import { useRecoilValue } from 'recoil';

import { userState } from 'state';

export function useProducerDisplayName() {
  const user = useRecoilValue(userState);
  if (user?.first_name || user?.last_name) {
    return [user.first_name, user.last_name].filter(Boolean).join(' ');
  }
  return user?.company ?? '';
}
